import React, { Component } from 'react'
import enhanceWithClickOutside from 'react-click-outside'
import Counter from '../Counter/Counter'
import Field from '../Field/Field'
import './PartySelector.scss'
import PropTypes from 'prop-types'

class PartySelector extends Component {
  state = {
    isOpen: false,
  }

  togglePartySelector = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  handleClickOutside = () => {
    this.setState({
      isOpen: false,
    })
  }

  getMinValue = key => {
    const { minPassengers, groupDetails } = this.props
    const [adults, children] = groupDetails.party
    switch (key) {
      case 'adults':
        return minPassengers - children.value
      case 'children':
        return minPassengers - adults.value
      default:
        return 0
    }
  }

  render() {
    const { handleChange, groupDetails, labels, children, summary } = this.props
    const { isOpen } = this.state
    return (
      <div className="PartySelector">
        <Field
          label={labels.passengersLabel}
          placeholder={summary}
          info={labels.groupDescription}
          active={isOpen}
          icon="groups"
          handleClick={this.togglePartySelector}
        />
        {isOpen && (
          <section className="PartySelector__wrapper">
            {groupDetails.party.map(group => (
              <Counter
                counterValue={group.value}
                step={1}
                minValue={this.getMinValue(group.key)}
                maxValue={group.maxValue}
                handleChange={handleChange}
                name={group.key}
                id={group.key}
                key={group.key}
                label={group.label}
                hint={`${group.hint} ${labels.yearsLabel}`}
                required={group.required}
                customClassName="PartySelector__counter"
              />
            ))}
            {children}
          </section>
        )}
      </div>
    )
  }
}

PartySelector.propTypes = {
  summary: PropTypes.string,
  contextRedirect: PropTypes.func,
  groupDetails: PropTypes.object,
  handleChange: PropTypes.func,
  minPassengers: PropTypes.number,
  validation: PropTypes.shape({
    minGroupSize: PropTypes.bool,
    minAdult: PropTypes.bool,
    minAdultPerBaby: PropTypes.bool,
  }),
  children: PropTypes.node,
  labels: PropTypes.shape({
    minGroupSizeMessage: PropTypes.string,
    minAdultMessage: PropTypes.string,
    minAdultPerBabyMessage: PropTypes.string,
  }),
}

export default enhanceWithClickOutside(PartySelector)
